import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ReactGA from 'react-ga4';

import { Routers } from './routers';

// state managers
import { QueryClient, QueryClientProvider } from 'react-query';
import { UserContextProvider } from './context/userContext';
import { ConfigContextProvider } from './context/configContext';

// global styles
import './App.scss';
import GlobalStyles from './styles/global';


import theme from './styles/theme';

const ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID ?? '';

ReactGA.initialize(ANALYTICS_ID);

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        onError: (error: any) => {
          if (error.request.status === 401) {
            window.location.href = 'login'
          }
        }
      }
    }
  });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <QueryClientProvider client={queryClient}>
          <ConfigContextProvider>
            <UserContextProvider>
              <BrowserRouter>
                <Routers />
              </BrowserRouter>
            </UserContextProvider>
          </ConfigContextProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
